<span style="font-size:9px;float:right; margin-top: 820px;margin-right: 10px;">Ver O3.016.76.56</span>
<section class="welcome-page" dir="{{languageDir}}">
  <app-welcome-banner [bgImage]="leftBannerImgurl" [ngClass]="languageDir === 'rtl' ? 'banner-logo-center' : ''"></app-welcome-banner>

  <div class="welcome-content">
    <div class="welcome-top-bar">
      <ul class="top-list d-flex justify-content-end align-items-center">
        <li>
          <form [formGroup]="translateForm" style="display:inline-flex">
            <img  src="{{imageSrc}}" class="lang-wh" alt="image" style="margin-top: 6px;">  
            <mat-select class="form-control-lang" style="width: 65px;" 
            #selectedLang 
            formControlName="languagvalue"
            (selectionChange)="translater.switchLang(selectedLang.value);changeLang(selectedLang.value)">
          
              <mat-option *ngFor="let language of translater.translate.getLangs()" [value]="language"> 
                <img *ngIf="language === 'en'" src="/assets/images/english.png" class="lang-wh" alt="image">
                <img *ngIf="language === 'ar'" src="/assets/images/arabic.png" class="lang-wh" alt="image">
                <img *ngIf="language === 'fr'" src="/assets/images/french.png" class="lang-wh" alt="image">
                <img *ngIf="language === 'sp'" src="/assets/images/spanish.png" class="lang-wh" alt="image">
                <img *ngIf="language === 'gr'" src="/assets/images/german.png" class="lang-wh" alt="image">
                <img *ngIf="language === 'du'" src="/assets/images/dutch.png" class="lang-wh" alt="image">
                {{ language |  uppercase }}
              </mat-option>
            </mat-select>
          </form>
        </li>
        <li>
          <a mat-button class="btn-base" routerLink="/customer-complaint">{{langObj ? langObj?.CustomerPortal : ('CustomerPortal' | translate)}}</a>
        </li>
        <li>
          <a mat-button class="btn-base">{{langObj ? langObj?.newuser : ('newuser' | translate)}}</a>
        </li>
        <li>
          <a mat-flat-button color="accent" routerLink="/signup" class="btn-accent">{{langObj ? langObj?.signup : ('signup' | translate)}}</a>
        </li>
      </ul>
    </div>
    <div class="welcome-form-area">
      <h2 class="welcome-title">{{langObj ? langObj?.login : ('login' | translate)}}</h2>
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="form-group">
          <label class="label" for="email">{{langObj ? langObj?.email : ('email' | translate)}}</label>
          <input [ngClass]="{
            'is-invalid':
              loginForm.get('email')?.errors &&
              loginForm.get('email')?.touched
          }" type="email" formControlName="email" class="form-control form-control-lg" placeholder="{{langObj ? langObj?.email : ('email' | translate)}}" required
            autocomplete="off">
          <p class="invalid-feedback" *ngIf="
          loginForm.get('email')?.touched &&
          loginForm.get('email')?.hasError('required')
        ">
            * invalid email
          </p>
          <p class="invalid-feedback" *ngIf="
            loginForm.get('email')?.hasError('email') &&
            loginForm.get('email')?.touched
          ">
            * invalid email
          </p>
        </div>
        <div class="form-group">
          <label class="label" for="password">{{langObj ? langObj?.password : ('password' | translate)}}</label>
          <input [ngClass]="{
            'is-invalid':
              loginForm.get('password')?.errors &&
              loginForm.get('password')?.touched
          }" type="password" formControlName="password" class="form-control form-control-lg" placeholder="{{langObj ? langObj?.password : ('password' | translate)}}"
            required autocomplete="off">
          <p class="invalid-feedback" *ngIf="
          loginForm.get('password')?.touched &&
          loginForm.get('password')?.hasError('required')
        ">
            * password is required
          </p>
          <p class="invalid-feedback" *ngIf="
          loginForm.get('password')?.touched &&
          loginForm.get('password')?.hasError('minLength')
        ">
            * password is atleast 4 characters
          </p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <mat-checkbox color="accent"> {{langObj ? langObj?.rememberme : ('rememberme' | translate)}} </mat-checkbox>
          <button type="button" mat-button class="btn-base btn-simple" routerLink="/forgotpassword">{{langObj ? langObj?.forgotpassword : ('forgotpassword' | translate)}}</button>
        </div>
        <button mat-flat-button color="accent" class="btn-accent btn-lg submit-btn">
          <!-- [disabled]="!loginForm.valid" -->
          {{langObj ? langObj?.login : ('login' | translate)}}
        </button>
        <ngx-spinner [fullScreen]="false" bdColor="#fff" size="medium" color="#050a4f" type="ball-clip-rotate-multiple">
          <p style="font-size: 20px; color: #050a4f">Authenticating...</p>
        </ngx-spinner>
      </form>
    </div>
  </div>
</section>